export default __webpack_public_path__ + "static/avatar-kortical-team-4b99a1df29d95051fea7bdcd75a62e01.webp";